// src/components/ReceiptModal.js
import React, { useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import html2canvas from 'html2canvas';

const ReceiptModal = ({ show, onHide, transaction }) => {
  const receiptRef = useRef();

  const handleDownload = () => {
    html2canvas(receiptRef.current).then(canvas => {
      const link = document.createElement('a');
      link.download = `Recibo-${transaction.id}.png`;
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  if (!transaction) return null;

  // Normaliza "Arzú Alajuela" -> "arzualajuela", etc.
  const getWhatsappNumber = tienda => {
    const key = tienda
      .normalize("NFD")               // elimina tildes
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "");           // quita espacios
    const map = {
      arzualajuela: "88003973",
      arzuheredia: "87339744",
      arzunazaret: "87268324",       // si cambias nombres, actualiza aquí
      arzubc:      "84123156"
    };
    return map[key] || null;
  };

  const whatsappNumber = getWhatsappNumber(transaction.tienda);
  const encodedMessage = encodeURIComponent(
    `Hola, soy ${transaction.buyerName} y realicé una compra de ₡${transaction.amount.toLocaleString()} en la tienda ${transaction.tienda}. ¿Cuándo puedo pasar por el pedido?`
  );
  const whatsappLink = whatsappNumber && `https://wa.me/506${whatsappNumber}?text=${encodedMessage}`;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Comprobante de Pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div ref={receiptRef} className="p-4 border rounded text-center bg-light">
          <h4 className="mb-3">Arzú Store</h4>
          <p><strong>ID:</strong> {transaction.id}</p>
          <p><strong>Nombre:</strong> {transaction.buyerName}</p>
          <p><strong>Fecha:</strong> {new Date(transaction.date).toLocaleString()}</p>
          <p><strong>Monto:</strong> ₡{transaction.amount.toLocaleString()}</p>
          <p><strong>Moneda:</strong> {transaction.currency}</p>
          <p><strong>Código autorización:</strong> {transaction.authorizationCode}</p>
          <p><strong>Tienda seleccionada:</strong> {transaction.tienda}</p>
          <p className="mt-3 text-muted small">Imprima o guarde este recibo para sus registros.</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {whatsappLink && (
          <Button variant="success" onClick={() => window.open(whatsappLink, "_blank")}>
            Contactar vía WhatsApp
          </Button>
        )}
        <Button variant="secondary" onClick={handleDownload}>
          Descargar como imagen
        </Button>
        <Button variant="primary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReceiptModal;
